export default {
  fields: {
    country: 'Pankin maa',
    iban: 'IBAN',
    routing_number: 'Pankkitunnus (routing number)',
    account_number: 'Tilinumero',
    sort_code: 'Pankin tunnuskoodi (sort code)',
    account_type: 'Tilin tyyppi',
  },
  help: {
    country: 'Pankin maa, joka voi olla eri kuin ravintolan maa.',
  },
  placeholders: {
    iban: 'FI21 1234 5600 0007 85',
  },
  formats: {
    uk_local: {
      title: 'Tunnuskoodi ja tilinumero',
      description: 'Tavallinen tapa syöttää brittiläinen tili.',
    },
    iban: {
      title: 'IBAN',
      description: 'Kansainvälinen pankkitilinumero.',
    },
    us_local: {
      title: 'Pankkitunnus ja tilinumero',
      description: 'Yhdysvaltalainen pankkitili.',
    },
  },
  account_types: {
    checking: 'Käyttötili',
    savings: 'Säästötili',
  },
  actions: {
    save: 'Tallenna pankkitili',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
  },
  card: {
    account: 'Tili',
    country: 'Maa',
    status: 'Tila',
  },
  statuses: {
    active: 'Aktiivinen',
    pending_verification: 'Vahvistetaan',
    action_needed: 'Toimenpide vaaditaan',
    errored: 'Maksu epäonnistui',
    missing: 'Puuttuu',
  },
  notes: {
    pending_verification:
      'Adyen tarkistaa jokaisen pankkitilin ennen maksujen aloittamista. Vahvista se Adyenin sivulla pankkitunnuksilla tai tiliotteella.',
    action_needed: 'Maksupalveluntarjoaja ei voinut vahvistaa tätä pankkitiliä. Tarkista tiedot tai syötä toinen tili.',
    errored: 'Maksu tälle tilille epäonnistui, ja maksut on keskeytetty. Tarkista tiedot tai syötä toinen tili.',
  },
};
